import { IconOrderedListOutline18 as ListOrdered } from "nucleo-ui-outline-18"

import { ShortcutSymbols } from "@productlane/lib/src/shortcut-symbols"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const numberedListCommand: SlashCommandDefinition = {
	key: "numbered-list",
	title: "Numbered list",
	icon: <ListOrdered strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).toggleOrderedList().run()
	},
	group: "lists",
	shortcutIcons: [
		ShortcutSymbols.CMD,
		ShortcutSymbols.SHIFT,
		ShortcutSymbols[7],
	],
}
